var zooomyColl= function(jQuery) {
	var getwishselector = document.querySelectorAll(".zoomywishid");
	var getwishselectorlength = getwishselector.length;
	var ifruncode = getwishselectorlength;
	var myurlcheck = document.location.href;

	var checktrue = myurlcheck.includes("login");
	if (checktrue == false) {
		checktrue = myurlcheck.includes("register");
	}
	if (checktrue == false) {
		checktrue = myurlcheck.includes("challenge");
	}
	if (checktrue == false) {
		checktrue = myurlcheck.includes("account");
	}
	if (checktrue == false) {
		checktrue = myurlcheck.includes("cart");
	}
   if (checktrue == false) {
		checktrue = myurlcheck.includes("pages");
	}
   if (checktrue == false) {
		checktrue = myurlcheck.includes("blog");
	}	
   if (checktrue == false) {
		checktrue = myurlcheck.includes("policies");
	}	
   if (checktrue == false) {
		checktrue = myurlcheck.includes("collections");
	}			
	if (checktrue) {
		getwishselectorlength = 1;
	}

	//console.log(myurlcheck);

	if (getwishselectorlength == 0) {} else {
        window.$=jQuery
        let callAjax=1;
		function wishlist(callAjaxLen) {
    		var WishIdsArray = [];
			var WishIds = "";
			let getwishselector = $(".zoomywishid");
			$(getwishselector).each(function() {
				if ($(this).html().trim() == '') {
					WishIds = $(this).attr("data-product-id");
					WishIdsArray.push(WishIds);
				}
			});
          
			var shop = "";
			var customerid = "";
			var scripts = document.getElementsByTagName("script");
			for (var i = 0, l = scripts.length; i < l; i++) {
				if (scripts[i].getAttribute("data-shop-id") != null) {
					shop = scripts[i].getAttribute("data-shop-id");
					customerid = scripts[i].getAttribute("data-cus-id");
					customername = scripts[i].getAttribute("data-cus-name");
					customer_email = scripts[i].getAttribute("data-cus-email");
				}
			}

			$.ajax({
				url: "https://zooomyapps.com/wishlist/Coll.php?WishIdsArray=" + WishIdsArray + "&customerid=" + customerid + "&shop=" + shop + "&ifruncode=" + ifruncode,
				data: {},
				dataType: "jsonp",
				jsonp: "jsonCode",
				async: "true",
				success: function(jsonData) {
					var usercss = jsonData.custom_css;
					var useraddedcss = jsonData.user_Added_css;
					var empty = jsonData.empty;
					var itemadded = jsonData.itemadded;
					var coll_f_color = jsonData.coll_f_color;
					var coll_e_color = jsonData.coll_e_color;
					var login_text = jsonData.login_text;
					var shop = jsonData.shop;
					var totalv = jsonData.totalv;
					var wish_icon= jsonData.wish_icon;
					if (jsonData.l_f_color == undefined) {
						jsonData.l_f_color = "#000";
						jsonData.l_b_color = "#a4dfc7";
						jsonData.l_br_color = "#277f4e";

					}
    				if ($('#zooomy-wishlist-counter').length){
    					$("#zooomy-wishlist-counter").append("<span>"+totalv+"</span>");
    				}
                    if ($('.zooomyIconval').length) {
                        if (totalv > 0) {
                            $('.zooomyIconval i.fa').addClass('fa-heart').removeClass('fa-heart-o');
                        } 
                    }

					$('<link rel="stylesheet" type="text/css" href="https://maxcdn.bootstrapcdn.com/font-awesome/4.3.0/css/font-awesome.min.css">').appendTo("body");

					if (jsonData.w_login == "yes") {
						$("body").append(
							'<a class="zooomy__hhrt" href="/pages/' +
							jsonData.p_link +
							'" style="position:fixed;bottom:100px;right:10px;width:48px; height:48px; line-height: 52px; border-radius: 100px; text-align: center; font-size: 20px;"><i class="fa fa-'+wish_icon+'"></i></a>'
						);
						$("<style>.zooomy__hhrt{z-index:9999;background:" + coll_f_color + "!important;color:" + jsonData.add_font_color + "!important;}</style>").appendTo("body");
					}
					$(
						"<style>body{position:relative;}.zoomywishid { width:100%;float: left;  padding: 0; }.zoomywishidheart { float: left; width: 100%; }.zooomywishmsg:hover .collnoitem {  }.zooomywishmsg .fa{margin-right:3px;}.zoomywishid .fa { font-size: 18px; }.zoomycheck{position:absolute;visibility:hidden;}p.zooomywishmsg .fa{margin:0; padding:2px 10px;margin:0;}p.collnoitem { float: left; width: 100%; padding: 10px 0; margin:0; }p.zooomywishmsg.zrmvbg{color:" +
						coll_e_color +
						"}p.zooomywishmsg.zadbg{color:" +
						coll_f_color +
						"}.zwishoverlay { z-index:99999;position: fixed; top: 0; bottom: 0; left: 0; right: 0; background: rgba(0, 0, 0, 0.7); transition: opacity 500ms; display: none; opacity: 0; } .zwishoverlay:target { display: block; opacity: 1; } .zwishlistmodal {  padding: 20px; border-radius: 5px; width: 30%; position: relative; transition: all 5s ease-in-out; } .zwishlistmodal h2 { margin-top: 0; color: #333; font-family: Tahoma, Arial, sans-serif; } .zwishlistmodal .close { position: absolute; top: 20px; right: 30px; transition: all 200ms; font-size: 30px; font-weight: bold; text-decoration: none; color: #333; } .zwishlistmodal .close:hover { color: #06D85F; } .zwishlistmodal .content { max-height: 30%; overflow: auto; } @media screen and (max-width: 700px){ .zwishlistmodal{ width: 70%; } }</style>"
					).appendTo("body");


					$("<style>" + usercss + "</style>").appendTo("body");
					$("<style>" + useraddedcss + "</style>").appendTo("body");
					var alldata = {};
					if (jsonData.app_plan != "free") {
						if (getwishselector.length == 0) {} else {
							$(getwishselector).each(function() {
								var productid = $(this).attr("data-product-id");
								
								if (jsonData.itemadded[productid] == "yes") {
									hearticon =
										"<div class='zoomywishidheart' style='position:relative;'><input type='checkbox' data-id='" +
										productid +
										"' class='zoomycheck checkbox-" +
										productid +
										"'   id='checkbox-" +
										productid +
										"'/><label for ='checkbox-" +
										productid +
										"'><p class='zooomywishmsg zooomywishmsg-" +
										productid +
										"'><i class='fa fa-"+wish_icon+"' style='color: " +
										coll_f_color +
										";'></i></p></label</div>";
								}else{
                                  var hearticon =
									"<div class='zoomywishidheart' style='position:relative;'><input type='checkbox' data-id='" +
									productid +
									"' class='zoomycheck checkbox-" +
									productid +
									"' id='checkbox-" +
									productid +
									"'/><label for ='checkbox-" +
									productid +
									"'><p class='zooomywishmsg zooomywishmsg-" +
									productid +
									"'><i class='fa  fa-"+wish_icon+"-o' style='color: " +
									coll_e_color +
									";'></i></p></label</div>";
                                }
								$(".zoomywishid-" + productid).html(hearticon);
							});
						}
					}

					if (customerid == "") {
						if (jsonData.w_login == "yes") {
							var myallwishlist = "";
							let data = [];
                            if(callAjaxLen==1){
    							$("body").on("click", ".zoomycheck", function() {
    								var productid = $(this).attr("data-id");
    								var handle = $(".zoomywishid-" + productid).attr("data-handle");
    								var vid = $(".zoomywishid-" + productid).attr("data-variant");
    								var vname = $(".zoomywishid-" + productid).attr("data-variantname");
    								var proprice = $(".zoomywishid-" + productid).attr("data-price");
    								var protitle = $(".zoomywishid-" + productid).attr("data-title");
    								var proimage = $(".zoomywishid-" + productid).attr("data-image");
    
    								alldata = {
    									product_id: productid,
    									product_handle: handle,
    									vid: vid,
    									vname: vname,
    									proprice: proprice,
    									protitle: protitle,
    									proimage: proimage
    								};
    
    								if (localStorage.getItem("myzooomy__wishlist") == undefined) {} else {
    									let item = localStorage.getItem("myzooomy__wishlist");
    									data = JSON.parse(item);
    
    
    
    
    								}
    
    								if ($(".checkbox-" + productid).prop("checked") == true) {
    									$(".zooomywishmsg-" + productid).replaceWith('<p class="zooomywishmsg zadbg zooomywishmsg-' + productid + '" style="cursor:pointer;"><i class="fa  fa-'+wish_icon+'" aria-hidden="true"  ></i></p>');
    									var whiProductInfo = data.filter(function(hero) {
    										return hero.product_id == productid;
    									});
    									if (whiProductInfo.length == 0) {
    
    										data.push(alldata);
    									}
    									$(".zwishfixed").append(
    										"<div class='" +
    										productid +
    										"' style='width:25%;float:left;padding:10px;box-sizing:border-box;'><a class='rfw' data-id='" +
    										productid +
    										"'>x</a><div class='' style=''><a href='https://" +
    										shop +
    										"/products/" +
    										handle +
    										"' target='_blank'><img src='" +
    										proimage +
    										"' width='100'/</a><div class='zall_details'><p><a href='https://" +
    										shop +
    										"/products/" +
    										handle +
    										"' target='_blank'>" +
    										protitle +
    										"</a></p><span class='wish_price money' >" +
    										proprice +
    										"</span><div class='zbtn'><a href='https://" +
    										shop +
    										"/products/" +
    										handle +
    										"' target='_blank'>View Product</a></div></div></div></div>"
    									);
    									if (shop != "happily-ever-a.myshopify.com") {
    										$.ajax({
    											url: "https://zooomyapps.com/wishlist/ZooomyGuestWishlist.php",
    											data: {
    												shop: shop,
    												productid: productid,
    												title: protitle,
    												handle: handle,
    												proimage: proimage,
    												price: proprice,
    												vname: vname
    											},
    											dataType: "jsonp",
    											jsonp: "guestdatacode",
    											async: "true",
    											success: function(gjsonData) {},
    										});
    									}
    								} else if ($(".checkbox-" + productid).prop("checked") == false) {
    									$(".zooomywishmsg-" + productid).replaceWith('<p class="zooomywishmsg zrmvbg zooomywishmsg-' + productid + '" style="cursor:pointer;"><i class="fa  fa-'+wish_icon+'-o" aria-hidden="true"  ></i></p>');
    									data = data.filter((product) => {
    										return product.product_id != productid;
    									});
    									$("." + productid).remove();
    								}
    
    								var myJSON = JSON.stringify(data);
    
    								localStorage.setItem("myzooomy__wishlist", myJSON);
    
    			                     if ($('#zooomy-wishlist-counter').length){
    
    								 document.getElementById("zooomy-wishlist-counter").innerHTML = "<span>"+data.length+"</span>";  
    
    		                        }
    		                        		                        if ($('.zooomyIconval').length) {
    if (data.length > 0) {
        $('.zooomyIconval i.fa').addClass('fa-heart').removeClass('fa-heart-o');
    } else {
        $('.zooomyIconval i.fa').addClass('fa-heart-o').removeClass('fa-heart');

    }
}
    
    							});
                            }
							if (localStorage.getItem("myzooomy__wishlist") == undefined) {} else {
								let nnitem = localStorage.getItem("myzooomy__wishlist");
								let nndata = JSON.parse(nnitem);
								$.each(nndata, function(key, value) {
									var pidsall = value.product_id;
									hearticon =
										"<div class='zoomywishidheart' style='position:relative;'><input type='checkbox' data-id='" +
										pidsall +
										"' class='zoomycheck checkbox-" +
										pidsall +
										"'   id='checkbox-" +
										pidsall +
										"' checked='true'/><label for ='checkbox-" +
										pidsall +
										"'><p class='zooomywishmsg zadbg zooomywishmsg-" +
										pidsall +
										"'><i class='fa fa-"+wish_icon+"' style='color: " +
										coll_f_color +
										";'></i></p></label</div>";
									$(".zoomywishid-" + pidsall).html(hearticon);
									$(".zwishfixed").append(
										"<div class='" +
										pidsall +
										"' style='width:25%;float:left;padding:10px;box-sizing:border-box;'><a class='rfw' data-id='" +
										pidsall +
										"'>x</a><div class='' style=''><a href='https://" +
										shop +
										"/products/" +
										value.product_handle +
										"' target='_blank'><img src='" +
										value.proimage +
										"' width='100'/</a><div class='zall_details'><p><a href='https://" +
										shop +
										"/products/" +
										value.product_handle +
										"' target='_blank'>" +
										value.protitle +
										"</a></p><span class='wish_price money' >" +
										value.proprice +
										"</span><div class='zbtn'><a href='https://" +
										shop +
										"/products/" +
										value.product_handle +
										"' target='_blank'>View Product</a></div></div></div></div>"
									);
								});
							}
										if ($('#zooomy-wishlist-counter').length){
                       if (localStorage.getItem("myzooomy__wishlist") !== null || localStorage.getItem("myzooomy__wishlist") != null || localStorage.getItem("myzooomy__wishlist") != undefined) 
					      {
							var y = JSON.parse(localStorage.getItem("myzooomy__wishlist")).length;
							document.getElementById("zooomy-wishlist-counter").innerHTML = "<span>"+y+"</span>";
						}
						}
								                        if ($('.zooomyIconval').length) {
	var y = JSON.parse(localStorage.getItem("myzooomy__wishlist")).length;

    if (y > 0) {
        $('.zooomyIconval i.fa').addClass('fa-heart').removeClass('fa-heart-o');
    } else {
        $('.zooomyIconval i.fa').addClass('fa-heart-o').removeClass('fa-heart');

    }
}

						} else {
							$("body").append(
								"<div class='zooomyloginrequest' id='zooomyloginrequestonce'><a href='https://" + shop + "/account/login'>" + login_text + "</a> <span id='zloginrequestclose'><i class='fa fa-close'></i></span> </div>"
							);
							$("#zooomyloginrequestonce").each(function() {
								$('[id="' + this.id + '"]:gt(0)').remove();
							});
							$("body").on("click", ".zoomywishid", function(e) {
								var productid = $(this).attr("data-product-id");

								$(".zooomyloginrequest").show("100");

								$(
									"<style>.zooomyloginrequest a{color:" + jsonData.l_f_color + ";text-decoration:none;}#zloginrequestclose .fa{color:#fff;}#zloginrequestclose{cursor: pointer; background: #000; color: #fff; border-radius: 62px; width: 20px; height: 20px; line-height: 20px; text-align: center; float: right; padding: 0; margin-left: 10px;}body{position:relative;}.zooomyloginrequest{z-index:99999;display:none;position: fixed; top: 0; right: 0; background: " + jsonData.l_b_color + "; border: 1px solid " + jsonData.l_br_color + "; padding: 17px;}</style>"
								).appendTo("body");

								$("#zloginrequestclose").click(function() {
									$(".zooomyloginrequest").hide("100");
								});
								$(document).ready(function() {
									setTimeout(function() {
										$(".zooomyloginrequest").fadeOut(1500);
									}, 5000);
								});
							});
						}
					}

					if (customerid != "") {
						if (localStorage.getItem("myzooomy__wishlist") !== null) {
							if (localStorage.getItem("myzooomy__wishlist") == undefined) {} else {
								let nnitem = localStorage.getItem("myzooomy__wishlist");
								let nndata = JSON.parse(nnitem);
								$.each(nndata, function(key, value) {
									$.ajax({
										url: "https://zooomyapps.com/wishlist/SaveData.php",
										data: {
											shop: Shopify.shop,
											productid: value.product_id,
											title: value.protitle,
											handle: value.product_handle,
											img: value.proimage,
											price: value.proprice,
											customerid: customerid,
											customername: customername,
											customer_email: customer_email,
										},
										dataType: "jsonp",
										jsonp: "savedatacode",
										async: "true",
										success: function(ajsonData) {
											data = data.filter((product) => {
												return product.product_id != ajsonData.productid;
											});
										},
									});
								});
								localStorage.removeItem("myzooomy__wishlist");
							}
						}
                        if(callAjaxLen==1){
    						$("body").on("click", ".zoomywishid", function(e) {
    							var productid = $(this).attr("data-product-id");
    							if ($(".zooomywishmsg-" + productid + " i").is(".fa-"+wish_icon)) {
    								$(".zooomywishmsg-" + productid).replaceWith('<p class="zooomywishmsg zrmvbg zooomywishmsg-' + productid + '" style="cursor:pointer;"><i class="fa fa-'+wish_icon+'-o" aria-hidden="true"  ></i></p>');
    							}
    							if ($(".zooomywishmsg-" + productid + " i").is(".fa-"+wish_icon+"-o")) {
    								$(".zooomywishmsg-" + productid).replaceWith('<p class="zooomywishmsg  zooomywishmsg-' + productid + '" style="cursor:pointer;"><i class="fa fa-'+wish_icon+'" aria-hidden="true"  ></i></p>');
    							}
    							$.ajax({
    								url: "https://zooomyapps.com/wishlist/CollCheck2.php",
    								data: {
    									shop: Shopify.shop,
    									productid: productid,
    									customerid: customerid
    								},
    								dataType: "jsonp",
    								jsonp: "mylinkprocode",
    								async: "true",
    								success: function(njsonData) {
    									var status = njsonData.done;
    									var productid = njsonData.productid;
    
    
    									if (status == "done") {
    										$(".checkbox-" + productid).prop("checked", true);
    										$(".zooomywishmsg-" + productid).replaceWith('<p class="zooomywishmsg zadbg zooomywishmsg-' + productid + '" style="cursor:pointer;"><i class="fa  fa-'+wish_icon+'" aria-hidden="true"  ></i></p>');
    													if ($('#zooomy-wishlist-counter').length){
    									     const container = document.getElementById('zooomy-wishlist-counter');
    
    										document.getElementById("zooomy-wishlist-counter").innerHTML = "<span>"+parseInt(container.innerText) + 1+"</span>";
    									}
    
    
    									}
    									if (status == "ndone") {
    										$(".checkbox-" + productid).prop("checked", false);
    										$(".zooomywishmsg-" + productid).replaceWith('<p class="zooomywishmsg zrmvbg zooomywishmsg-' + productid + '" ><i class="fa  fa-'+wish_icon+'-o" aria-hidden="true" ></i> </p>');
    													if ($('#zooomy-wishlist-counter').length){
    									     const container = document.getElementById('zooomy-wishlist-counter');
    
    document.getElementById("zooomy-wishlist-counter").innerHTML = "<span>"+parseInt(container.innerText) - 1+"</span>";
    }
    
    									}
										                        if ($('.zooomyIconval').length) {
    if (newtotalval > 0) {
        $('.zooomyIconval i.fa').addClass('fa-heart').removeClass('fa-heart-o');
    } else {
        $('.zooomyIconval i.fa').addClass('fa-heart-o').removeClass('fa-heart');

    }
}
    								},
    							});
    
    							e.stopPropagation();
    							return false;
    						});
                         } 
					} else {
						$("body").on("click", ".zoomywishid", function(e) {
							var productid = $(this).attr("data-product-id");
						});
					}

				},
			});



		}
		wishlist(callAjax);
        if ($('#zooomy-wishlist-counter').length){
          setTimeout(function() { 
            var text = document.getElementById("zooomy-wishlist-counter").innerHTML;

                        if(text == "00" || text=="")
                        {
                        document.getElementById("zooomy-wishlist-counter").innerHTML = "<span>0</span>"; 

                        }

           }, 300);

           }
		$(window).scroll(function() {
  
			if (getwishselector.length > 0) {
               
				clearTimeout($.data(this, 'scrollTimer'));
				$.data(this, 'scrollTimer', setTimeout(function() {
					let checkWishList = [];
					let WishIds = ''
					let getwishselectorScroll = $(".zoomywishid");
					$(getwishselectorScroll).each(function() {
                      
						if ($(this).html().trim() == '') {
                         
							WishIds = $(this).attr("data-product-id");
                           console.log('..',WishIds)
							checkWishList.push(WishIds);
						}
					});
					if (checkWishList.length > 0) {
                      callAjax++;
						wishlist(callAjax);
					}

				}, 300));
			}
		});
	}
};



function reqJquery(){var e,t;"undefined"==typeof jQuery||!jQuery||1===parseInt(jQuery.fn.jquery)&&parseFloat(jQuery.fn.jquery.replace(/^1\./,""))<11?(e=document.getElementsByTagName("head")[0],(t=document.createElement("script")).src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.6.1/jquery.min.js",t.type="text/javascript",t.onload=t.onreadystatechange=function(){t.readyState&&"complete"!==t.readyState&&"loaded"!==t.readyState||(t.onreadystatechange=null,zooomyColl(jQuery.noConflict(!0)))},e.appendChild(t)):zooomyColl(jQuery)}"product"==meta.page.pageType?setTimeout(reqJquery,2e3):reqJquery();
